﻿import { GliderDropdown } from './gliderDropdown';
import { RangeSelector } from './rangeSelector';

export const journeySelectorBlock = () => {
    let collapsibles = [];

    const gliderConfig =  [
        {
            breakpoint: 0,
            settings: {
                slidesToShow: 2,
                draggable: true,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 'auto',
            }
        },
        {
            breakpoint: 1200,
            settings: {
                exactWidth: true,
                slidesToShow: 'auto',
                dots: '',
            }
        }];
        
    const closeOthers = (allCollapsible, current) => {
        const filtered = allCollapsible
            .filter(collapsible => collapsible !== current);

        filtered.forEach(collapsible => collapsible.close());
    };

    const createRangeSelector = node => {
        const rangeSelector = new RangeSelector(node, function onOpened() {
            closeOthers(collapsibles, rangeSelector);
        });

        return rangeSelector;
    };

    const createDropdown = node => {
        const dropdown = new GliderDropdown(node, gliderConfig, null, function onOpened() {
            closeOthers(collapsibles, dropdown);
        });

        return dropdown;
    };
    
    const init = component => {

        const dropdownNodes = [...component.querySelectorAll(GliderDropdown.selectors.root)];
        const dropdowns = dropdownNodes.map(createDropdown);

        const rangeSelectorNodes = [...component.querySelectorAll(RangeSelector.selectors.root)];
        const rangeSelectors = rangeSelectorNodes.map(createRangeSelector);

        collapsibles = dropdowns.concat(rangeSelectors);
    };

    return {
        init: init,
        selector: "[data-component='journey-selector-block']"
    };
};